import { h } from '@stencil/core';
import { inputOut } from './utils';
import { customerFields } from '../store/customer-fields.store';
import { CustomField, CustomFieldValue } from '@artask/tambr-models/models/custom-field.model';
import { PrimaryField, UserForm } from './models';
import { orderFields } from '../store/order-fields.store';


export function addCustomFieldToForm(
  form: UserForm,
  customField: CustomField,
  customFieldValue?: CustomFieldValue, 
) {
  form[ customField.id ] = {
    type: customField.type,
    title: customField.title,
    isRequired: customField.isRequired,
    value: customFieldValue?.value || getCustomFieldDefaultValue( customField )
  };
}


function getCustomFieldDefaultValue( customField: CustomField ) {
  switch( customField.type ) {
    case 'text': return '';
    case 'checkbox': return false;
    case 'select': return null;
  }
}


export function handleFormFieldChange( 
  form: UserForm,
  event: any, 
  field: string,
  isCheckbox: boolean = false
) {
  const value = isCheckbox ? event.target.checked : event.target.value;
  form[ field ].value = value;
}


export function getFormErrors(
  form: UserForm
) {
  const errors: string[] = [];
  for ( let key in form ) {
    if ( form[ key ].isRequired && !form[ key ].value ) {
      errors.push(`${ form[ key ].title } is required.`);
    } 
  }
  return errors;
}

export function renderField( form: UserForm, field: CustomField | PrimaryField, isReadOnly: boolean = false ) { 
  switch( field.type ) {
    case 'text': return renderFieldText( form, field, isReadOnly );
    case 'checkbox': return renderFieldCheckbox( form, field );
    case 'select': return renderFieldSelect( form, field );
  }
}

export function renderFieldText( form: UserForm, field: CustomField | PrimaryField, isReadOnly: boolean = false ) {
  return (
    <div class='tambr-form-item'>
      <input type='text' 
        class={ form[ field.id ].value ? 'has-value' : '' }
        id={ field.id } name={ field.id } value={ form[ field.id ].value } 
        readonly={ isReadOnly }
        onInput={ (event) => handleFormFieldChange( form, event, field.id ) }
        onBlur={ (event) => inputOut( event ) } />
      <label htmlFor={ field.id }>{ field.title }</label>
    </div>
  );
}

export function renderFieldCheckbox( form: UserForm, field: CustomField | PrimaryField ) {
  return (
    <div class='checkbox-wrapper'>
      <input type='checkbox' id={ field.id } name={ field.id } 
        checked={ form[ field.id ].value } 
        onInput={ (event) => handleFormFieldChange( form, event, field.id, true ) } />
      <label htmlFor={ field.id }>{ field.title }</label>
    </div>
  );
}

export function renderFieldSelect( form: UserForm, field: CustomField | PrimaryField ) {
  return (
    <div class='tambr-form-item'>
      <select id={ field.id } name={ field.id }
        class={ form[ field.id ].value ? 'has-value' : '' }
        onInput={ (event) => handleFormFieldChange( form, event, field.id ) }
        onBlur={ (event) => inputOut( event ) }>
          <option value='' selected>Select</option>
          {
            field.options.map( ( option ) => {
              return <option value={ option } selected={ option === form[ field.id ].value }>{ option }</option>
            } )
          }
      </select>
      <label htmlFor={ field.id }>{ field.title }</label>
    </div>
  )
}

export function renderCustomerFields( form: UserForm ) {
  if ( !customerFields.customFields?.length || customerFields.customerFieldsLoading ) return;
  return customerFields.customFields.map( ( customField ) => renderField( form, customField ));
}

export function renderOrderFields( form: UserForm ) {
  if ( !orderFields.customFields?.length || orderFields.orderFieldsLoading ) return;
  return orderFields.customFields.map( ( customField ) => renderField( form, customField ) );
}

export function getCustomFieldValues(form: UserForm, customFields: CustomField[]) {
  const customFieldValues: CustomFieldValue[] = [];
  for ( let customField of customFields ) {
    customFieldValues.push({
      id: customField.id,
      title: customField.title,
      type: customField.type,
      value: form[ customField.id ].value
    })
  }
  return customFieldValues;

}